import React, { useEffect, useState } from 'react';
import styles from './checkbox.module.css';

interface CheckboxProps {
    label: string;
    isLabelFirst?: boolean;
    name?: string;
    value: string | number | boolean;
    checked: boolean;
    disabled?: boolean;
    info?: string | React.ReactNode;
    onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
    type?: 'radio' | 'checkbox';
    useMargin?: boolean;
    readOnly?: boolean;
}

const Checkbox = ({
    type = 'checkbox',
    label,
    name,
    value,
    checked,
    disabled,
    info,
    onChange,
    isLabelFirst,
    useMargin = true,
    readOnly = false,
}: CheckboxProps) => {
    const [isChecked, setIsChecked] = useState(checked || false);

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setIsChecked(event.target.checked);

        onChange && onChange(event);
    };

    useEffect(() => {
        if (checked !== isChecked) {
            setIsChecked(checked);
        }
    }, [checked]);

    return (
        <label
            className={`${styles.label} ${useMargin ? styles.offset : ''} ${disabled ? styles.disabled : ''} ${readOnly ? styles.readOnly : ''}`}
        >
            <input
                type={type}
                name={name}
                value={value?.toString() || ''}
                checked={checked}
                onChange={handleChange}
                className={styles.input}
                disabled={disabled}
                readOnly={readOnly}
            />
            {isLabelFirst && !!label && <span className={styles.label}>{label}</span>}

            <span className={`${styles.checkbox} ${isChecked ? styles.checked : ''}`} />

            {!isLabelFirst && !!label && <span className={styles.label}>{label}</span>}

            {/*{info && (*/}
            {/*    <span className={`${styles.tip} ${disabled ? styles.disabled : ''}`}>*/}
            {/*        <span className={styles.tipBtn}>*/}
            {/*            <span className={styles.tipBtnImg}>*/}
            {/*                <img alt={''} src={'/icons/info.png'} />*/}
            {/*                <img alt={''} src={'/icons/info-active.png'} />*/}
            {/*            </span>*/}
            {/*        </span>*/}

            {/*        <p className={styles.tipBox}>{info}</p>*/}
            {/*    </span>*/}
            {/*)}*/}
        </label>
    );
};

export default Checkbox;
